import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import AdminServices from '../../services/AdminServices'
function AddAdmin() {
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    name: '',
    role: '',
    email: '',
    mobileNo: '',
    city: '',
    password: '',
  });



  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };



  const handleSubmit = async (event) => {
    event.preventDefault();
    try {

      await AdminServices.createAdmin(formValues);
      alert('Admin details created successfully');
      navigate('/admin');
    } catch (error) {
      console.error('Failed to create admin details', error);
    }
  };


  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

          <div className="my-auto">

            <h5 className="page-title fs-21 mb-1">
              Admin Add User            </h5>
            <nav>

              <ol className="breadcrumb mb-0">

                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Admin Add
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
            <Link className="list-banner-btn" to="/admin">User List</Link>

          </div>
        </div>

        <div className="container-box">
          <div className="container-box-inner table-reponsive-tabe">
            <div className="row">
              <div className="col-md-12">
                <div className="page-details">
                  <form onSubmit={handleSubmit}>
                    <div className="input-field">
                      <label>User Type</label>
                      <select className="form-control" value={formValues.role}
                        onChange={handleInputChange} name="role">
                        <option value="">--Select Type--</option>
                        {/* <option value="Admin">Admin</option> */}
                        <option value="Helper">Helper</option>

                      </select>
                    </div>
                    <div className="input-field">
                      <label>Name</label>
                      <input type="text" name="name" value={formValues.name}
                        onChange={handleInputChange} placeholder='Name' className="form-control" />
                    </div>
                    <div className="input-field">
                      <label>Email</label>
                      <input type="text" name="email" value={formValues.email}
                        onChange={handleInputChange} placeholder='Email' className="form-control" />
                    </div>
                    <div className="input-field">
                      <label>Mobile No.</label>
                      <input type="text" name="mobileNo" value={formValues.mobileNo}
                        onChange={handleInputChange} placeholder='MobileNo' className="form-control" />
                    </div>
                    <div className="input-field">
                      <label>City</label>
                      <input type="text" name="city" value={formValues.city}
                        onChange={handleInputChange} placeholder='City' className="form-control" />
                    </div>
                    <div className="input-field">
                      <label>Password</label>
                      <input type="text" name="password" value={formValues.password}
                        onChange={handleInputChange} placeholder='******' className="form-control" />
                    </div>
                    <button className="submit-green-btn">SUBMIT</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddAdmin